import React, { Component, ComponentType } from 'react';
import { connect } from 'react-redux';
import { getTabData } from '../redux/dynamicTabs/selectors';
import { RootState } from '../redux/reducers';
import { init } from '../redux/dynamicTabs/actions';
// import { Loader } from 'react-inv-forms';

type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;
type MapStateToProps = ReturnType<typeof mapStateToProps>;

export interface WithDynamicTabStateProviderProps<TLeftPanel> {
  state: DynamicTabWithTable<TLeftPanel> | DynamicTabWithForm<TLeftPanel>;
}

type ComponentProps = DynamicTabComponent;
export type ViewDataSetHandler = ComponentProps & MapStateToProps & MapDispatchToProps;

/**
 * HOC dostarczający stan reduxowy dla zakładek dynamicznych.
 * Podczas montowania komponentu inicjalizowane jest pobieranie danych.
 * Jako argument należy podać komponent widoku zakładki dynamicznej (posiadającej props 'id').
 *
 * @param Cmp
 */
const withDynamicTabStateProvider = <P extends ComponentProps>(Cmp: ComponentType<P>) => {
  class Controller extends Component<ViewDataSetHandler> {
    componentDidMount(): void {
      if (this.props.state.initTable) {
        this.props.init();
      }
    }
    render(): React.ReactElement {
      const { state, init, ...rest } = this.props;
      return <Cmp {...(rest as P)} state={state} />;
    }
  }
  return connect(mapStateToProps, mapDispatchToProps)(Controller);
};
const mapStateToProps = (state: RootState, { id }: ComponentProps) => ({
  state: getTabData(state, id),
});

const mapDispatchToProps = (dispatch: any, { id }: ComponentProps) => ({
  init: () => dispatch(init(id)),
});

export default withDynamicTabStateProvider;
